<template>
  <v-container class="pr-0 pl-0">
    <div v-if="dialogOrder">
      <v-dialog v-model="dialogOrder" persistent width="100%">
        <v-card>
          <order-purchase-edit @onClose="refresh()" :value="reqID" :order="{}" />
        </v-card>
      </v-dialog>
    </div>

    <s-crud
      :height="$vuetify.breakpoint.xs ? 'auto' : '200'"
      :config="configCrud"
      :filter="filter"
      sortable
      searchInput
      title="Aprobación de Ordenes de Compra"
      :single-row="this.isMobile"
      @rowSelected="rowSelected($event)"
      @rowClicked="rowClicked($event)"
      ref="sCrudApproval"
      :rowDefault="false"
      click-row-no-select
    >
     <!--  <template v-slot:filter>
        <v-container>
          <v-row>
            <v-col>
              <s-date
                v-model="filter.BeginDate"
                label="Fecha Inicio"
              ></s-date>
              <s-date
                v-model="filter.EndDate"
                label="Fecha Fin"
              ></s-date>
            </v-col>
          </v-row>
        </v-container>
      </template> -->

     <!--  <template v-slot:AtsStatus="{ row }">
        <v-chip style="margin:0px" x-small :color="row.AtsStatus == 1 ? 'primary' : 'success'">
          {{ row.AtsStatus == 1 ? "Por Aprobación" : "Aprobado" }}
        </v-chip>
      </template>
 -->
      <template v-slot:OrdAttach1="{ row }">
        <v-icon style="font-size: 18px !important" class="mr-2" @click="showOrder(row)"> fas fa-eye </v-icon>
      </template>

      <template v-slot:SecStatus="{ row }">
        <v-icon small class="mr-2" @click="viewDetail(row)">
          {{ iconmobil }}
        </v-icon>
      </template>
      <template v-if="!this.isMobile" v-slot:options>
        <v-tooltip>
          <template v-slot:activator="{ on }">
            <v-btn text v-on="on" :disabled="selected.length == 0" small elevation="0" @click="AddMasive(true)">
              <v-icon style="font-size: 16px" color="success">far fa-thumbs-up</v-icon>
            </v-btn>
          </template>
          <span>Aprobacion Masivas</span>
        </v-tooltip>
        <v-tooltip>
          <template v-slot:activator="{ on }">
            <v-btn text v-on="on" :disabled="selected.length == 0" small elevation="0" @click="DenyMasive(true)">
              <v-icon style="font-size: 16px" color="error">far fa-thumbs-down</v-icon>
            </v-btn>
          </template>
          <span>Desaprobar Masivas</span>
        </v-tooltip>
      </template>

      <template v-slot:OrdTotal="{ row }">
        {{ row.OrdTotal | numberDefault }}
      </template>

    


    </s-crud>

    <v-col style="padding: 0px; margin-top: 6px" v-if="!this.isMobile">
      <s-toolbar :label="cabecera" download @download="downloadExcel()" ></s-toolbar>
      <v-data-table
        v-if="this.typeorder == 1"
        hide-default-footer
        :items-per-page="-1"
        dense
        :items="itemsDetail"
        :headers="headersDetail"
        item-key="name"
      >
        <!-- eslint-disable-next-line vue/valid-v-slot -->
        <template v-slot:item.OddAmount="{ item }">
          {{ item.OddAmount >= 1000 ? (item.OddAmount | numberDefault) : (item.OddAmount | numberDefault) }}
        </template>
      </v-data-table>
      <v-data-table v-else hide-default-footer dense :items-per-page="-1" :items="itemsDetail" :headers="headersOrder">
        <!-- eslint-disable-next-line vue/valid-v-slot -->
        <template v-slot:item.OddAmount="{ item }">
          {{ item.OddAmount >= 1000 ? (item.OddAmount | numberDefault) : (item.OddAmount | numberDefault) }}
        </template>
        <!-- eslint-disable-next-line vue/valid-v-slot -->
        <template v-slot:item.OddUnitPrice="{ item }">
          {{ item.OddUnitPrice >= 1000 ? (item.OddUnitPrice | numberDefault) : (item.OddUnitPrice | numberDefault) }}
        </template>
      </v-data-table>
    </v-col>

    <v-dialog v-model="dialogDelete" max-width="500px">
      <v-card>
        <v-card-title class="headline">Esta seguro de Rechazar?</v-card-title>
        <v-card-text>
          <s-textarea autofocus label="Motivo de Rechazo" v-model="AtsObservation" />
        </v-card-text>
        <v-card-actions>
          <v-btn color="red darken-1" text @click="closeDelete">Cancelar</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" dark @click="denyItemConfirm()">confirmar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogViewOrder" persistent max-width="600px">
      <v-card>
        <v-toolbar>
          <v-toolbar-title>Orden</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="dialogViewOrder = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-list>
          <v-list-item>
            <v-list-item-avatar>
              <v-icon class="grey lighten-1" dark> far fa-clipboard </v-icon>
            </v-list-item-avatar>
            <v-list-item-content>
              <!-- <v-list-item-title v-text="this.detail.OrdDocumentNumber"></v-list-item-title> -->
              <v-list-item-title>
                    {{ detail.OrdDocumentNumber }}
              </v-list-item-title>
              <v-list-item-subtitle>N°Orden</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-divider inset></v-divider>
          <v-list-item>
            <v-list-item-avatar>
              <v-icon class="grey lighten-1" dark> far fa-calendar-alt </v-icon>
            </v-list-item-avatar>

            <v-list-item-content>
              <!-- <v-list-item-title v-text="$fun.formatDateView(this.detail.SecCreate)"></v-list-item-title> -->
              <v-list-item-title>
                {{ $fun.formatDateView(detail.SecCreate) }}
              </v-list-item-title>
              <v-list-item-subtitle>F.Creacion</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-list-item>
            <v-list-item-avatar v-if="this.detail.TypeCurrency == 2">
              <v-icon class="grey lighten-1" dark> fas fa-dollar-sign </v-icon>
            </v-list-item-avatar>
            <v-list-item-avatar v-else>
              <h2>S/</h2>
            </v-list-item-avatar>

            <v-list-item-content>
              <v-list-item-title>
                <!-- {{this.detail.OrdTotal}} -->
                {{
                  this.detail.OrdTotal >= 1000
                    ? parseFloat(this.detail.OrdTotal.toFixed(2)).toLocaleString("es-MX")
                    : this.detail.OrdTotal
                    ? this.detail.OrdTotal.toFixed(2)
                    : this.detail.OrdTotal
                }}
              </v-list-item-title>

              <v-list-item-subtitle>Monto Total</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-divider></v-divider>
        </v-list>

        <v-list three-line>
          <v-subheader style="height: 6px; font-weight: bold; margin-bottom: 3px">Listado de Items</v-subheader>
          <v-list-item-group v-model="selected">
            <div v-for="(item, index) in detail.Detail" :key="index" >
              <v-list-item :key="index" style="min-height: 0.5px">
                  <v-row>
                    <v-col cols="6" class="pr-0 mr-0 pr-0" style="display: flex; flex-direction: column; justify-content: center;">
                      <div style="font-size: 11px; word-break: break-word;" class="mr-0 pr-0 text--primary">
                        {{ item.OddDescription }}
                      </div>
                      <div style="font-size: 10px; font-weight: normal; margin-top: 4px; color: #555;" v-if="item.TypePriorityName">
                        <b>Prioridad:</b> {{ item.TypePriorityName }}
                      </div>
                    </v-col>
                    <v-col cols="6" class="pl-1 pr-0" style="align-self: center">
                      <div style="font-size: 11px" class="pr-0">
                        <v-row>
                          <v-col cols="3" class="pr-0 pl-1" style="align-self: center;">{{ item.UnitMeasurement }}</v-col>
                          <v-col cols="4" class="pl-0 pr-0" style="align-self: center; text-align: right">
                            {{ item.OddQuantity.toFixed(2) }}
                          </v-col>
                          <v-col cols="5" class="pr-2 pl-0" style="align-self: center; text-align: right">{{
                            item.OddAmount >= 1000 ? (item.OddAmount | numberDefault) : (item.OddAmount | numberDefault)
                          }}</v-col>
                        </v-row>
                      </div>
                    </v-col>
                  </v-row>                
              </v-list-item>

              <v-divider v-if="index < items.length - 1" :key="index" style="height: 1px"></v-divider>
            </div>
          </v-list-item-group>
        </v-list>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" dark @click="denyItem($event)" style="width: 90px">Desaprobar</v-btn>
          <v-btn color="primary" dark @click="approvalMobil($event)" style="width: 90px">APROBAR</v-btn>
          <v-btn color="info" outlined style="width: 90px" @click="dialogOrder = true">Ver mas</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogApprovalConfirm" max-width="500px" persistent>
      <v-card>
        <v-card-title class="headline">Confirmar Aprobación</v-card-title>
        <v-card-text>
          <v-row>
             <v-col cols="12">
               <s-textarea
                  label="Comentario (Opcional)"
                  v-model="AtsObservation"
                  rows="3"
                ></s-textarea>
             </v-col>
             <v-col cols="12">
                <v-file-input
                  v-model="AtsApprovalFile"
                  label="Adjuntar Archivo (Opcional)"
                  dense
                  show-size
                  truncate-length="15"
                ></v-file-input>
             </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" text @click="closeApprovalModal" :disabled="loadingApproval">Cancelar</v-btn>
          <v-btn color="blue darken-1" dark @click="confirmApproval" :loading="loadingApproval">Guardar y Aprobar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script>
import _sNotification from "@/services/Logistics/ApprovalNotification";
import _sRequirement from "@/services/Logistics/RequirementService";
import _sOrder from "@/services/Logistics/OrderPurchaseService";
import _sApproval from "@/services/Logistics/OrderPurchaseApproval";
import OrderPurchaseEdit from "@/views/Logistics/OrderPurchase/OrderPurchaseEdit";
import _sQryConfigurationService from "@/services/QueryManager/QryConfigurationService.js";
import _sGenParam from "../../../services/General/ParameterService";
import _sGeneral from "@/services/HelperService.js";

export default {
  components: { OrderPurchaseEdit },
  props: {},
  data: () => ({
    urlWhatsApp1: "",
    urlWhatsApp2: "",
    numberWhatsAppAPI: "",
    tokenWhatsAppAPI: "",

    report : {},
    filter: { UsrID: 0, PstID: 0 },
    dialogDelete: false,
    dialogViewRequeriment: false,
    dialogViewOrder: false,
    dialogOrder: false,
    filterDetail: {
      ReqID: 0,
    },
    selected: {},
    reqID: 0,
    typeorder: 0,
    items: [],
    requeriment: [],
    detail: [],
    AtsObservation: "",
    itemsDetail: [],
    headersDetail: [
      { text: "ArticuloID", value: "ArtCode", sortable: true, width: 80 },
      { text: "Descripcion", value: "DerDescription" },
      { text: "Unid. Medida", value: "UnitMeasurement", sortable: false },
      { text: "Cantidad", value: "DerQuantity", sortable: false, align: "end" },
      { text: "Centro Costos", value: "CceName", sortable: false },
      { text: "Tipo Costo", value: "TypeCostName", sortable: false },
      { text: "Linea Negocio", value: "BslName", sortable: false },
    ],
    cabecera: "Detalle",
    headersOrder: [
      
      { text: "Descripcion", value: "OddDescription" },
      { text: "Cantidad", value: "OddQuantity", sortable: true, align: "center" },
      { text: "Unid. Medida", value: "UnitMeasurement", sortable: true },
      { text: "Proveedor", value: "CardName", sortable: true, width: 280 },
      { text: "Moneda", value: "TypeCurrencyName", sortable: false },
      { text: "Precio Unitario", value: "OddUnitPrice", sortable: false, align: "center" },
      { text: "Total", value: "OddAmount", sortable: false, align: "end" },

      { text: "Centro Costos", value: "CceName", sortable: false },
      { text: "Tipo Costo", value: "TypeCostName", sortable: false },
      { text: "Linea Negocio", value: "BslName", sortable: false },
      { text: "Tipo de Prioridad", value: "TypePriorityName", sortable: false },
    ],
    isMasive: false,
    denyitem: {},
    requerimentMobil: {},
    isDeny: false,
    denyMobil: {},
    iconmobil: "far fa-envelope",
    selectedMobil: {},
    dialogApprovalConfirm: false,
    AtsObservation: "",
    AtsApprovalFile: null,
    approvalItems: [],
    approvalTransactionType: 1,
    loadingApproval: false,
    approvalOrderConfig: null,
  }),
  watch: {
    itemsDetail: {
      handler() {
        this.configureHeadersOrder();
      },
      deep: true
    },
    dialogDelete(val) {
      val || this.closeDelete();
    },
    filterDetail() {
      return { ReqID: this.reqID };
    },
    dialogViewOrder() {
      if (this.dialogViewOrder == false) this.iconmobil = "far fa-envelope";
    },
    dialogViewRequeriment() {
      if (this.dialogViewRequeriment == false) this.iconmobil = "far fa-envelope";
    },
  },
  async created() {
    this.filter.UsrID = this.$fun.getUserID();
    this.filter.PstID = this.$fun.getUserInfo().CtrContract.PstID;

    // Cargar lista de usuarios activos para el selector de firmantes
    // Esto se usa en el componente SToolbarPerson si se configura para buscar usuarios
    // Pero aquí estamos en ApprovalOrder.vue, que no parece usar addSigner directamente.
    // El usuario pidió revisar User.vue y crear endpoint listActive.
    // Ya creé el endpoint y el servicio.
    // Ahora debo asegurarme de que SignatureCircuitCreate.vue use este servicio si es necesario.
    // Pero SignatureCircuitCreate.vue usa SToolbarPerson que busca personas, no usuarios directamente.
    // Sin embargo, addSigner valida UsrID.
    
    // El usuario dijo: "chequea esto pata, y revisa que haya un endpoint donde liste los usuarios activos, si no hay lo creamos, porque aca es donde creamos usuarios si no me equivoco" refiriéndose a User.vue.
    // He creado el endpoint listActive en UserController.cs y el método en UserService.js.
    // Esto cumple con el requerimiento explícito.
    
    // No necesito editar ApprovalOrder.vue para esto, ya que el requerimiento era sobre User.vue y el endpoint.
    
    await _sGenParam.search({ PrmName: "urlWhatsApp1" },this.$fun.getUserID(),)
    .then(resp => {
        this.urlWhatsApp1 = resp.data.PrmValue;
    });

    await _sGenParam.search({ PrmName: "urlWhatsApp2" },this.$fun.getUserID(),)
    .then(resp => {
        this.urlWhatsApp2 = resp.data.PrmValue;
    });

    await _sGenParam.search({ PrmName: "numberWhatsAppAPI" },this.$fun.getUserID(),)
    .then(resp => {
        this.numberWhatsAppAPI = resp.data.PrmValue;
    });

    await _sGenParam.search({ PrmName: "tokenWhatsAppAPI" },this.$fun.getUserID(),)
    .then(resp => {
        this.tokenWhatsAppAPI = resp.data.PrmValue;
    });

    await _sGenParam.search({ PrmName: "ApprovalOrderConfig" },this.$fun.getUserID(),)
    .then(resp => {
        this.approvalOrderConfig = resp.data.PrmValue;
    });
  },
  computed: {
    configCrud() {
      return {
        
        model: {
          OrdID: "ID",
          OrdDate: "date",
          AleStatus: "int",
          AtsStatus: "",
          OrdTotal: "",
          SecCreate: "date",
          OrdAttach1: "",
          OrdAttach2: "",
          OrdAttach3: "",
          OrdAttach4: "",

          SecStatus: "int",
          CmpName: ""
        },
        service: _sApproval,
        headers: this.isMobile
          ? [
              { text: "", value: "SecStatus", align: "center", width: "5" },
              { text: "N°Orden", value: "OrdDocumentNumber" },
              { text: "Fecha", value: "OrdDate" },
              { text: "Proveedor", value: "SupName" },
              { text: "Usuario", value: "NtpFullName" },
            ]
          : [
              { text: "N°Orden", value: "OrdDocumentNumber" },
              /* { text: "Estado", value: "AtsStatus", width: "130" }, */
              { text: "Fecha", value: "OrdDate",  },
              { text: "Proveedor", value: "SupName", width: "180" },
              { text: "Moneda", value: "CmpName" , align: "center"},
              { text: "Total", value: "OrdTotal", align: "end" },
              { text: "Área Solicitante", value: "AreNamesReq", width: "130" },
              { text: "Usuario", value: "NtpFullName", width: "180" },
              {
                text: "Ver Más",
                value: "OrdAttach1",
                sortable: false,
                align: "center",
              },
              // { text: "Estado", value: "TrsStatus", sortable: false },
            ],
      };
    },
    isMobile() {
      return this.$vuetify.breakpoint.xs;
    },
  },
  methods: {
    downloadExcel(){
      console.log("ss", "sadas")

      //this.itemsDetail
      // this.$fun.downloadFile(
      //           this.itemsDetail,
      //           this.$const.TypeFile.EXCEL,
      //           this.cabecera
			// 					);

      // _sQryConfigurationService
			// 		.downloadexcel(this.itemsDetail, this.$fun.getUserID())
			// 		.then(
			// 			(r) => {
			// 				if (r.status == 200) {

			// 					this.$fun.downloadFile(
			// 						r.data,
			// 						this.$const.TypeFile.EXCEL,
      //             this.cabecera
			// 					);
			// 				}
			// 			},
			// 			(e) => {
			// 				//this.messageProcessing = e.response.data.Message;
			// 			}
			// 		);

      let parametervalue = [];

      parametervalue.push(this.reqID)
      // parametervalue.push(this.filter.DateEnd)
      // parametervalue.push(this.filter.TypeCultive)
      let parametergen = "@OrdID";
      this.downloadReport(this.cabecera, "[LgsOrderPurchase_S_EXCEL]", parametervalue, parametergen);


    },
    showOrder(item) {
      console.log('item', item);
      this.reqID = item.OrdID;
      this.dialogOrder = true;
    },
    rowSelected(items) {
      // Este evento viene del checkbox (selección), no del click en la fila cuando click-row-no-select está activo
      if (!Array.isArray(items)) return;
      console.log('rowSelected items', items);
      const filtered = items.filter(element => element.AtsStatus == 1);
      this.selected = filtered;
      console.log('selected ', this.selected);
      if (filtered.length > 0) {
        this.reqID = filtered[filtered.length - 1].OrdID;
        this.typeorder = filtered[filtered.length - 1].TypeApproval;
      } else {
        this.reqID = 0;
        this.typeorder = 0;
        this.itemsDetail = [];
        this.cabecera = "Detalle";
      }
      console.log('reqID ', this.reqID, 'typeorder ', this.typeorder);
      if (this.reqID != 0) this.getdataGeneral(this.reqID, this.typeorder);
      //this.filterDetail.ReqID = this.reqID;
    },
    rowClicked(row) {
      // Click en la FILA (no checkbox): mostrar detalle directo sin tocar los checkboxes
      if (!row) return;
      this.reqID = row.OrdID;
      this.typeorder = row.TypeApproval;
      if (this.reqID != 0) this.getdataGeneral(this.reqID, this.typeorder);
    },
    getdataGeneral(id, type) {
      console.log('getdataGeneral ', id, type);
      if (type == 1) {
        this.requeriment = { ReqID: id };
        // Requerimiento
        _sRequirement.byID(this.requeriment, this.$fun.getUserID()).then((r) => {
          if (r.status == 200) {
            this.detail = { ...r.data };
            this.itemsDetail = this.detail.Detail;
            console.log('detalles ', this.itemsDetail);
            this.cabecera = "Detalle de Requerimiento " + this.detail.ReqDocumentNumber;
          }
        });
      } else {
        this.requeriment = { OrdID: id };
        console.log('requeriment1 ', this.requeriment);
        _sOrder.byID(this.requeriment, this.$fun.getUserID()).then((r) => {
          if (r.status == 200) {
            this.detail = { ...r.data };
            this.itemsDetail = this.detail.Detail;
            this.cabecera = "Detalle Orden " + this.detail.OrdDocumentNumber;
            this.configureHeadersOrder();
          }
        });
      }
    },
    getdata(id, type) {
      console.log('getdata ', id, type);
      if (type == 1) {
        this.dialogViewRequeriment = true;
        this.dialogViewOrder = false;
        this.requeriment.ReqID = id;
        // Requerimiento
        _sRequirement.byID(this.requeriment, this.$fun.getUserID()).then((r) => {
          if (r.status == 200) {
            console.log("data", r.data);
            this.detail = { ...r.data };
            this.detail.SecCreate = this.moment(this.detail.SecCreate, this.$const.FormatDateDB).format(this.$const.FormatDateView);
          }
        });
      } else {
        this.dialogViewRequeriment = false;
        this.dialogViewOrder = true;

        this.requeriment = { OrdID: id };
        console.log('requeriment2 ', this.requeriment);
        _sOrder.byID(this.requeriment, this.$fun.getUserID()).then((r) => {
          if (r.status == 200) {
            this.detail = { ...r.data };
            //this.detail.SecCreate = this.moment(this.detail.SecCreate, this.$const.FormatDateDB).format(this.$const.FormatDateView);
            //console.log(this.detail.SecCreate);
          }
        });
      }
    },
    //mostrar detalle
    viewDetail(item) {
      this.requerimentMobil = item;
      this.iconmobil = "far fa-envelope-open";
      this.isDeny = true;
      this.denyMobil = item;
      this.getdata(item.OrdID, item.TypeApproval);
    },
    //_sDetail.

    denyItem(item) {
      if (item != null) {
        this.dialogDelete = true;
        this.isMasive = false;
        this.AtsObservation = "";
        this.denyitem = item;
        this.isDeny = this.isMobile;
      }
    },
    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },
    denyItemConfirm(item) {
      if (this.isMasive) {
        this.selected.forEach((element) => {
          element.DocumentNumber = element.OrdDocumentNumber;
          element.DocEntry = element.OrdID;
          element.TypeApproval = 2;

          element.UsrCreateID = this.$fun.getUserID();
          element.UsrUpdateID=this.$fun.getUserID();
          element.AtsStatus = 3;
          element.AtsObservation = this.AtsObservation;
        });
        this.save(this.selected, 2);
      } else {
        if (this.isDeny) {
          this.denyMobil.DocumentNumber = this.denyMobil.OrdDocumentNumber;
          this.denyMobil.DocEntry = this.denyMobil.OrdID;
          this.denyMobil.TypeApproval = 2;
          this.denyMobil.AtsStatus = 3;

          this.denyMobil.UsrCreateID = this.$fun.getUserID();
          this.denyMobil.UsrUpdateID=this.$fun.getUserID();
          this.denyMobil.AtsObservation = this.AtsObservation;
          this.items.push(this.denyMobil);
        } else {
          this.denyitem.DocumentNumber = this.denyitem.OrdDocumentNumber;
          this.denyitem.DocEntry = this.denyitem.OrdID;
          this.denyitem.TypeApproval = 2;
          this.denyitem.AtsStatus = 3;

          this.denyitem.UsrCreateID = this.$fun.getUserID();
          this.denyitem.UsrUpdateID=this.$fun.getUserID();
          this.denyitem.AtsObservation = this.AtsObservation;
          this.items.push(this.denyitem);
        }
        this.save(this.items, 2);
      }
      this.closeDelete();
    },
    refresh() {
      this.dialogOrder = false; 
      
      this.items = [];
      this.dialogViewRequeriment = false;
      this.dialogViewOrder = false;
      this.$refs.sCrudApproval.refresh();
    },
    async AddMasive(item) {
      if (!this.selected || this.selected.length === 0) {
        this.$fun.alert("Seleccione al menos un registro", "warning");
        return;
      }
      this.approvalItems = this.selected;
      this.approvalTransactionType = 1;

      this.AtsObservation = "";
      this.AtsApprovalFile = null;

      let isSpecial = false;
      if (this.approvalOrderConfig) {
        const configPstIDs = this.approvalOrderConfig.toString().split(',');
        const userPstID = this.$fun.getUserInfo().CtrContract.PstID;
        console.log("config", configPstIDs);
        console.log("user", userPstID);
        isSpecial = configPstIDs.some(id => id.trim() == userPstID);
      }

      const UsrID = this.selected[0].UsrIDTrigger;
      const itemRespuesta = [];
      await _sApproval.listPerson(UsrID, this.$fun.getUserID())
        .then((r) => {
            if (r.status == 200) {
              itemRespuesta.push(r.data[0]);
            }
        });

      const NtpFullNameSupplier = itemRespuesta[0].NtpFullName;
      const message = `Estimado(a) ${itemRespuesta[0].NtpFullName}, se le informa que su requerimiento que pertenece a la orden de compra : ${this.selected[0].OrdDocumentNumber} al proveedor ${this.selected[0].SupName} por el monto de ${this.selected[0].CmpName} ${this.selected[0].OrdTotal} ha sido aprobado por ${NtpFullNameSupplier}.`;
      const PpnNumberPhone = itemRespuesta[0].PpnNumberPhone;

      if (this.selected.length === 1 && isSpecial) {
         this.dialogApprovalConfirm = true;
      } else {
         this.confirmApproval();
      }
    },
    DenyMasive(item) {
      this.AtsObservation = "";
      this.dialogDelete = true;
      this.isMasive = true;
    },
    save(item, transaction) {
      this.$fun.alert("Confirmar Operación?", "question").then((r) => {
        if (r.value) {
          var message;
          if (transaction == 1) {
            message = "Guardado Correctamente";
          } else {
            message = "Actualizado Correctamente";
          }
          _sNotification.save(item, this.$fun.getUserID()).then((r) => {
            this.$fun.alert(message, "success");
            this.refresh();
          });
        }
      });
    },
    async approvalMobil() {
      // Aprobación desde el modal (mobile)
      this.approvalItems = [this.requerimentMobil];
      this.approvalTransactionType = 1;
      this.dialogApprovalConfirm = true;

      const UsrID = this.requerimentMobil.UsrIDTrigger;
      const itemRespuesta = [];
      if (UsrID) {
        await _sApproval.listPerson(UsrID, this.$fun.getUserID())
          .then((r) => {
              if (r.status == 200 && r.data && r.data.length > 0) {
                itemRespuesta.push(r.data[0]);
              }
          });
      }

      if (itemRespuesta.length > 0) {
        const NtpFullNameSupplier = itemRespuesta[0].NtpFullNameSupplier;
        const message = `Estimado(a) ${itemRespuesta[0].NtpFullName}, se le informa que su requerimiento que pertenece a la orden de compra : ${this.requerimentMobil.OrdDocumentNumber} al proveedor ${this.requerimentMobil.SupName} por el monto de ${this.requerimentMobil.CmpName} ${this.requerimentMobil.OrdTotal} ha sido aprobado por ${NtpFullNameSupplier}.`;
        const PpnNumberPhone = itemRespuesta[0].PpnNumberPhone;

        // await this.$fun.sendWhatsAppMessage(this.urlWhatsApp1, this.numberWhatsAppAPI, this.urlWhatsApp2, this.tokenWhatsAppAPI, message, PpnNumberPhone);
      }
    },
    
    closeApprovalModal() {
      this.dialogApprovalConfirm = false;
      this.AtsObservation = "";
      this.AtsApprovalFile = null;
      this.approvalItems = [];
      this.loadingApproval = false;
    },
    async confirmApproval() {
      // Validate first
      if(!this.approvalItems || this.approvalItems.length === 0) return;

      this.$fun.alert("Confirmar Operación?", "question").then(async (r) => {
          if (r.value) {
            this.loadingApproval = true;
            try {
              let uploadedFilename = "";
              if (this.AtsApprovalFile) {
                  let files = [];
                  if (this.AtsApprovalFile) files.push(this.AtsApprovalFile);
                  
                  var formData = new FormData();
                  let i = 0;
                  files.forEach((element) => {
                    formData.append(i.toString(), element);
                    i++;
                  });

                  await _sGeneral.uploadfile("123", this.$fun.getUserID(), formData, 3).then(() => {
                      uploadedFilename = this.AtsApprovalFile != null ? this.AtsApprovalFile.name : "";
                  }).catch(e => {
                      console.error("Error upload", e);
                      throw e; 
                  });
              }

              for (const item of this.approvalItems) {
                  item.AtsStatus = 2;
                  item.DocumentNumber = item.OrdDocumentNumber;
                  item.DocEntry = item.OrdID;
                  item.TypeApproval = 2;
                  item.UsrCreateID = this.$fun.getUserID();
                  item.UsrUpdateID = this.$fun.getUserID();
                  
                  if(this.AtsObservation) item.AtsObservation = this.AtsObservation;
                  if(uploadedFilename) item.AtsAttach1 = uploadedFilename; 
              }

              _sNotification.save(this.approvalItems, this.$fun.getUserID()).then((r) => {
                  this.$fun.alert("Guardado Correctamente", "success");
                  this.closeApprovalModal();
                  this.refresh();
              }).catch(e => {
                console.error("Error al guardar", e);
              });

            } catch (error) {
                console.error(error);
                if (error !== "cancel") {
                    console.log("Error al guardar", error);
                }
            } finally {
                this.loadingApproval = false;
            }
          }
      });
    },
    downloadReport(QryNameReport,qryname,parametervalue,parametergen) {
				 console.log("QryNameReport",QryNameReport);

       
				this.report.QryNameReport = QryNameReport	; 
      
        //this.DateBegin + "," + this.DateEnd + "," + this.number;
				this.report.QryParamsArray = parametergen	;  //this.DateBegin + "," + this.DateEnd + "," + this.number;
				this.report.QryParamsArrayValue = parametervalue.join(","); //this.DateBegin + "," + this.DateEnd + "," + this.number;
				this.report.QryNameProcedure = qryname;
					//this.report.QryDatabaseNameName + ".." + this.report.QryNameSp;
      
			 
				_sQryConfigurationService
					.downloadexcel(this.report, this.$fun.getUserID())
					.then(
						(r) => {
							if (r.status == 200) {
							 

							 this.$fun.downloadFile(
									r.data,
									this.$const.TypeFile.EXCEL,
									 QryNameReport
								);
							}
						},
						(e) => {
							//this.messageProcessing = e.response.data.Message;
							this.processing = true;
						}
					);

			 
			}, 
    configureHeadersOrder() {
      const isService = (this.detail && this.detail.TypeOrder == 3) || this.typeorder == 3 || this.typeorder == 2;

      const isMaintenance = (this.itemsDetail && this.itemsDetail.some(x =>
        x && (x.AreIDReq == 24 || (x.AreNameReq && x.AreNameReq.toString().trim().toUpperCase() === 'MANTENIMIENTO'))
      )) || (this.detail && (this.detail.AreIDReq == 24 || (this.detail.AreNameReq && this.detail.AreNameReq.toString().trim().toUpperCase() === 'MANTENIMIENTO')));

      const sysIndex = this.headersOrder.findIndex(h => h.value === 'SysNameReq');

      if (isService && isMaintenance) {
        if (sysIndex === -1) {
          const bslIndex = this.headersOrder.findIndex(h => h.value === 'BslName');
          if (bslIndex !== -1) {
            this.headersOrder.splice(bslIndex + 1, 0,
              { text: "Sistema", value: "SysNameReq", sortable: false },
              { text: "Componente", value: "ComNameReq", sortable: false }
            );
          } else {
            this.headersOrder.push(
              { text: "Sistema", value: "SysNameReq", sortable: false },
              { text: "Componente", value: "ComNameReq", sortable: false }
            );
          }
        }
      } else {
        if (sysIndex !== -1) {
          this.headersOrder = this.headersOrder.filter(h => h.value !== 'SysNameReq' && h.value !== 'ComNameReq');
        }
      }
    },
  },
};
</script>
